import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/contexts/AppContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ScenariosPage from "@/pages/ScenariosPage";
import ScenarioDetailPage from "@/pages/ScenarioDetailPage";
import BuilderPage from "@/pages/BuilderPage";
import ContactPage from "@/pages/ContactPage";
import WhatsAppButton from "@/components/WhatsAppButton";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/scenarios" element={<ScenariosPage />} />
            <Route path="/scenarios/:slug" element={<ScenarioDetailPage />} />
            <Route path="/builder" element={<BuilderPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Layout>
        <WhatsAppButton />
        <Toaster richColors position="bottom-right" />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
